import api from '../../../services/api';
import {
  evalExport, evalGet, evalParams, listOf,
} from '../../../components/performance/evaluation/evaluationAnalytics';

// PM Analitik P4 — E05 Yetkinlik ve Gelişim Açıkları (/performance/competency-gaps) veri katmanı.
//   GET v1/performance-evaluation-analytics/competency-gaps/summary    (M54, M15, M16, M17 + veri eksik sayıları + yetkinlik seçenekleri)
//   GET …/competency-gaps/heatmap?dimension=department|title|manager    (yetkinlik × birim; k + tamamlayıcı gizleme sunucuda)
//   GET …/competency-gaps/top-areas                                     (en yaygın 10 gelişim alanı; kişi bazında tekil)
//   GET …/competency-gaps/records?view=gaps|noExpected|notScored&sort&order&pageNumber&pageSize (+ export=xlsx)
//   GET …/competency-gaps/findings                                      (kural tabanlı bulgular — LLM yok)
//   POST v1/development-plans/invite {employeeIds}                      (İK + TD.Write: taslak gelişim planı daveti, E12 akışı)

export const NS = 'performance.competencyGaps';

// Ekran düzeyi URL anahtarları (ortak süzgeç anahtarlarıyla çakışmaz; serializeFilters bunları korur).
export const Q = {
  competencies: 'comp',
  types: 'ctype',
  groups: 'cgroup',
  levels: 'elevel',
  bands: 'gband',
  plan: 'plan',
  persistent: 'persist',
  view: 'view',
  dimension: 'dim',
};
export const SCREEN_KEYS = Object.values(Q);

export const GAP_BANDS = ['major_gap', 'gap', 'meets', 'exceeds'];
export const NEGATIVE_BANDS = ['major_gap', 'gap'];
export const COMPETENCY_TYPES = ['behavioral', 'technical'];
export const LEVELS = ['1', '2', '3', '4', '5'];
export const VIEWS = ['gaps', 'noExpected', 'notScored'];
export const DIMENSIONS = ['department', 'title', 'manager'];
// Kademe / iş ailesi sütunları yalnız İK (sunucuda 403 — spec 2026-10-27 §7.6).
export const HR_DIMENSIONS = ['grade', 'jobFamily'];
export const dimensionsFor = (isHr) => (isHr ? [...DIMENSIONS, ...HR_DIMENSIONS] : DIMENSIONS);
export const RATER_GROUPS = ['self', 'manager', 'peer', 'subordinate', 'senior'];
export const HEATMAP_COLUMNS_PER_PAGE = 8;

/** URL değerleri → uç süzgeçleri (görünüm ve boyut ayrı parametredir). */
export function screenFilters(values) {
  return {
    'competencyId[in]': listOf(values[Q.competencies]),
    'competencyType[in]': listOf(values[Q.types]),
    'competencyGroup[in]': listOf(values[Q.groups]),
    'expectedLevel[in]': listOf(values[Q.levels]),
    'gapBand[in]': listOf(values[Q.bands]),
    hasPlan: values[Q.plan] || null,
    persistent: values[Q.persistent] || null,
  };
}

export const viewOf = (values) => (VIEWS.includes(values[Q.view]) ? values[Q.view] : 'gaps');
export const dimensionOf = (values, isHr = false) => (dimensionsFor(isHr).includes(values[Q.dimension]) ? values[Q.dimension] : 'department');

export const fetchSummary = (filters, screen) => evalGet('competency-gaps/summary', evalParams(filters, screen));
export const fetchHeatmap = (filters, screen, dimension) => evalGet('competency-gaps/heatmap', { ...evalParams(filters, screen), dimension });
export const fetchTopAreas = (filters, screen) => evalGet('competency-gaps/top-areas', evalParams(filters, screen));
export const fetchFindings = (filters, screen) => evalGet('competency-gaps/findings', evalParams(filters, screen));

const recordParams = (filters, screen, {
  view, sort, order, pageNumber, pageSize,
} = {}) => ({
  ...evalParams(filters, screen),
  view,
  ...(sort ? { sort, order: order || 'asc' } : {}),
  ...(pageNumber ? { pageNumber, pageSize } : {}),
});

export const fetchRecords = (filters, screen, options) => evalGet('competency-gaps/records', recordParams(filters, screen, options));
export const exportRecords = (filters, screen, options) => evalExport('competency-gaps/records', recordParams(filters, screen, { ...options, pageNumber: null }));

/** Taslak gelişim planı daveti (mevcut TD akışı; İK + TD.Write). Başarı/hata bildirimi Axios interceptor'ındadır. */
export async function inviteToIdp(employeeIds) {
  try {
    const res = await api.post('/v1/development-plans/invite', { employeeIds });
    return !!res?.data?.status;
  } catch {
    return false;
  }
}
